import {useEffect, useState, useRef} from "react";
import {getProductSuggestion} from "../services/searchService";
import {filterUniqueProducts} from "../utils/commonFunc";
import {useDebounce} from "../../customHook/customHook";

const MainController = ()=>{
    const [products, setProducts] = useState([])
    const [searchText, setSearchText] = useState(window?.searchProduct ?? "");
    const isInit=useRef(true)
    useEffect(() => {
        setSearchText(window?.searchProduct)
    }, [window?.searchProduct]);
    const fetchProducts = async () => {
        try {
            if(isInit.current===false){
                await getProductSuggestion({searchtext: searchText?.trim()??"", itemsPerPage: 5}, (data) => {
                    const uniqueProducts = filterUniqueProducts(data, 'name');
                    setProducts(uniqueProducts);
                });
            }
            isInit.current=false;
        } catch (e) {
            console.log(e);
        }
    }
    useDebounce(fetchProducts, searchText, 300);
    return {
        products,searchText,setSearchText,setProducts,fetchProducts
    }
}

export default MainController;
